import VTable from "@/components/table/index.vue";
import { mapGetters, mapActions } from "vuex";
import VLayout from "@/layouts/Default.vue";
import VPageHeader from "@/components/pageheader/PageHeader.vue";
import VLoader from "@/components/loader/index.vue";
// import EventBus from '@/plugins/event-bus';

export default {
    components: {
        VTable,
        VLayout,
        VPageHeader,
        VLoader
    },
    data() {
        return {
            name: "GroupsAssign",
            groupId: this.$route.params.id,
            filterBy: 'xx',
            userType: 'patient',
            selectAll: false,
            anySelected: false,
            searchValue: '',
            roles: {
                CARE_AUTHOR: "Author",
                CARE_NAVIGATOR: "Navigator"
            },
        };
    },
    beforeCreate: function () {
        // eslint-disable-next-line 
        console.log('beforeCreate in');
    },
    created: function () {
        // eslint-disable-next-line 
        console.log('created in');

        this._initInternal();
    },
    beforeMount: function () {
        // eslint-disable-next-line 
        console.log('beforeMount in');
    },
    computed: {
        ...mapGetters({
            // groups: "group/getAllGroups",
            // isLoading: "group/getLoading",
            // getGroupByIdFromState: "group/getGroupByIdFromState",
            isLoading: "group/isLoading",
            isBusy: "group/isBusy",
            getGroupInfo: "group/getGroupInfo",
            getGroupUserList: "group/getGroupUserList",
            permissions: "auth/getModulePermissions",
        }),
        // anySelected: function () {
        //     if (this.getGroupUserList && this.getGroupUserList.patientList) {
        //         return this.getGroupUserList.patientList.indexOf(x => x.isSelected) >= 0;
        //     } else {
        //         return false;
        //     }
        // }
    },
    watch: {
        // filter: {
        //     handler: "_getGroupUserListAll",
        //     immediate: true
        // },
        getGroupUserList: function (newVal) {
            if (newVal && newVal.patientList) {
                this.anySelected = (newVal.patientList.findIndex(x => x.isSelected == true) >= 0);
            } else {
                this.anySelected = false;
            }
        },
    },
    methods: {
        ...mapActions(
            'group', {}
        ),
        _initInternal() {
            this.$store.dispatch("group/clearState");
            this.$store.dispatch("group/getGroupInfo", this.groupId);
            this._filterBy('all');
        },
        _assign(gp) {
            this.$store.dispatch("group/assignGroupPatient", {
                type: 'assign',
                groupId: this.groupId,
                users: [gp.id]
            });
            //this._assignUsersInternal(this.groupId, [gp.id]);
        },
        _unassign(gp) {
            this.$store.dispatch("group/unassignGroupPatient", {
                type: 'unassign',
                groupId: this.groupId,
                users: [gp.id]
            });
            //this._unassignUsersInternal(this.groupId, [gp.id ]);
        },
        _filterBy(filterBy, userType) {
            // eslint-disable-next-line 
            console.log('_filterBy in');
            userType = userType || this.userType;

            if (this.filterBy == filterBy && this.userType == userType) {
                return;
            }

            this.filterBy = filterBy;
            this.userType = userType;

            const data = {
                groupId: this.groupId,
                userType: this.userType,
                filterType: this.filterBy,
                searchValue: "",
                limit: 20,
                skip: 0,
            };

            // eslint-disable-next-line 
            console.log('data -> data', data);

            this.$store.dispatch("group/getGroupUserList", data);
        },
        _userType(userType) {
            this._filterBy(this.filterBy, userType);
        },
        _loadMore() {
            // eslint-disable-next-line 
            console.log('_loadMore in');

            const data = {
                groupId: this.groupId,
                filterType: this.filterBy,
                searchValue: "",
                limit: 20,
                skip: this.getGroupUserList.patientList.length,
            };

            this.$store.dispatch("group/getGroupUserList", data);
        },
        selectAllChange() {
            this.$store.dispatch("group/selectAllItems", this.selectAll);
        },
        selectChange(gp) {
            this.$store.dispatch("group/selectOneItems", gp);
        },
        _assignAll() {

            const users = this.getGroupUserList.patientList
                .filter(x => x.isSelected && !x.group_id)
                .map(x => x.id);

            this._assignUsersInternal(this.groupId, users);

            // const data = {
            //     type: 'assign',
            //     groupId: this.groupId,
            //     patients: patients
            // };

            // this.$store.dispatch("group/assignUnassignMany", data);
        },
        _unassignAll() {
            const users = this.getGroupUserList.patientList
                .filter(x => x.isSelected && x.group_id)
                .map(x => x.id);

            this._unassignUsersInternal(this.groupId, users);
            // const data = {
            //     type: 'unassign',
            //     groupId: this.groupId,
            //     patients: patients
            // };

            // this.$store.dispatch("group/assignUnassignMany", data);
        },
        _assignUsersInternal(groupId, users) {
            const data = {
                type: 'assign',
                groupId: groupId,
                users: users
            };

            this.$store.dispatch("group/assignUnassignMany", data);
        },
        _unassignUsersInternal(groupId, users) {
            const data = {
                type: 'unassign',
                groupId: groupId,
                users: users
            };

            this.$store.dispatch("group/assignUnassignMany", data);
        },
        onSearchText(event) {
            this.searchValue = event.target.value;

            // eslint-disable-next-line
            console.log('onSearchText', this.searchValue);
        },
    },
};